import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { NoAccountant, NoAccountantForm } from "./noAccountantDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<NoAccountant>,
  data?: NoAccountant,
): NoAccountantForm {
  return new NoAccountantForm(context, data);
}

export function handleEvent() {}

export function isValid(form: NoAccountantForm): boolean {
  return form.previousAccountant !== undefined || form.data?.previousAccountant !== undefined;
}

export function validate(form: NoAccountantForm): boolean {
  return isValid(form);
}

export function applyForm(form: NoAccountantForm): NoAccountant {
  const snapshot = form.data?.previousAccountant ?? form.previousAccountant;
  if (!snapshot) {
    throw new Error("Cannot apply NoAccountant: company has no current accountant");
  }
  return {
    type: DecisionType.noAccountant,
    previousAccountant: snapshot,
  };
}

export const noAccountantHandler: DecisionTypeHandler<
  DecisionType.noAccountant,
  NoAccountant,
  NoAccountantForm
> = {
  type: DecisionType.noAccountant,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
